<template>
    <div class="shadow" v-if="isShow" @click="isShow = false">
        <div class="minutes-detail" @click.stop>
            <div class="title">
                預估時間
            </div>
            <div class="note">
                <div>系統使用以下三個資訊運算</div>
                <div>* 全部任務點的距離路程時間</div>
                <div>* 每位騎士抵達起點的平均時間</div>
                <div>* 平均每個地點所花費的時間</div>
            </div>
            <div class="tip">
                注意：如果現場需等候較久，則會往後推移預估時間
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'MinutesDetail',
        data() {
            return {
                isShow: false,
            }
        },
        methods: {
            show() {
                this.isShow = true;
            }
        }
    };
</script>

<style lang="scss" scoped>
    .shadow {
        z-index: 20;
        position: fixed;
        left: 0;
        top: 0;
        background-color: rgba(0, 0, 0, 0.4);
        width: 100%;
        height: 100%;
        max-width: 500px;
    }

    .minutes-detail {
        border-radius: 6px;
        background-color: rgba(255,255,255,1);
        box-shadow: 0 0 3px 0 rgba(51,153,51,0.35);
        padding: 15px;
        position: absolute;
        bottom: 65px;
        right: 15px;
        left: 15px;
        text-align: left;
        color: #4A4A4A;
        font-size: 12px;

        .title {
            font-size: 16px;
            font-weight: 500;
            line-height: 22px;
        }

        .note {
            margin-top: 20px;
            line-height: 20px;
        }

        .tip {
            margin-top: 10px;
            color: #F44336;
            line-height: 17px;
        }
    }
</style>
